.modal {
  max-width: 750px !important;
}

.links {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
  margin-top: 1.5rem;
}
